module.exports = __webpack_public_path__ + "static/media/work.723e8725.svg";